import { ArrowLeft, SearchX } from "lucide-react";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { PageFrame } from "@/components/admin/page-frame";
import { PageHeader } from "@/components/admin/page-header";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <PageFrame size="fluid">
      <PageHeader title="404" />
      <div className="mx-auto flex min-h-[50vh] w-full max-w-lg flex-1 flex-col items-center justify-center text-center">
        <div className="flex size-12 items-center justify-center rounded-md border border-line bg-panel-raised text-muted">
          <SearchX className="size-5" aria-hidden="true" />
        </div>
        <h2 className="mt-5 text-2xl font-semibold tracking-[-0.03em] text-ink">
          {t("common.noResults", "That admin route is not available")}
        </h2>
        <p className="mt-2 text-sm leading-6 text-muted">
          {t("common.noResultsDesc", "Use the search console to find a record, or return to the workspace.")}
        </p>
        <Button className="mt-6" variant="primary" onClick={() => window.history.back()}>
          <ArrowLeft className="size-4" aria-hidden="true" />
          {t("common.goBack", "Go back")}
        </Button>
        <Link className="mt-4 text-xs text-accent underline-offset-4 hover:underline" to="/admin/licenses">
          {t("nav.licenses", "Licenses")}
        </Link>
      </div>
    </PageFrame>
  );
}
